import { Link } from "react-router-dom";
import "./Card.scss";

const Card = ({ tenure, positon, description, link }) => {
  return (
    <div className="card__container">
      <div className="card__content">
        <div className="card__header">
          <span className="card__tenure">{tenure}</span>
          <h3 className="card__position">{positon}</h3>
        </div>
        <div className="card__body">
          <p className="card__description">{description}</p>
        </div>
        <div className="card__footer">
          <Link to={link} className="card__more-btn">
            Learn More
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="20"
              height="20"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <path d="M5 12h14M12 5l7 7-7 7" />
            </svg>
          </Link>
        </div>
      </div>
    </div>
  );
};

export default Card;
